var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0911 9H3.09106M17.0911 9C18.1956 9 19.0911 9.89543 19.0911 11V17C19.0911 18.1046 18.1956 19 17.0911 19H3.09106C1.98649 19 1.09106 18.1046 1.09106 17V11C1.09106 9.89543 1.9865 9 3.09106 9M17.0911 9V7C17.0911 5.89543 16.1956 5 15.0911 5M3.09106 9V7C3.09106 5.89543 3.9865 5 5.09106 5M5.09106 5V3C5.09106 1.89543 5.9865 1 7.09106 1H13.0911C14.1956 1 15.0911 1.89543 15.0911 3V5M5.09106 5H15.0911",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcScreen);
export default __webpack_public_path__ + "static/media/ic-screen.9b04c58748ff58fbcd99c9088c7d91e0.svg";
export { ForwardRef as ReactComponent };